export default __webpack_public_path__ + "static/media/nublado.e7f6b512.svg";